<template>
  <CDropdown
    class="rounded-2"
    :on-clickoutside="onClickOutside"
    :options="[
      {
        key: 'switcher-content',
        type: 'render',
        render: renderSwitcherContent,
      },
    ]"
    placement="bottom-start"
    :show="show"
    :themeOverrides="{
      peers: {
        Popover: {
          boxShadow: '0px 7px 24px 0px rgba(0, 0, 0, 0.1)',
        },
      },
    }"
    trigger="manual"
  >
    <CIcon
      v-tooltip="
        app === 'impact'
          ? t('canvasUI.components.CCatalogIqSwitcher.switchToAdmin')
          : t('canvasUI.components.CCatalogIqSwitcher.switchToCatalogIq')
      "
      class="ma-3 cursor-pointer"
      :color="themeVars.primary"
      faType="fas"
      icon="grid"
      size="16px"
      @click="show = !show"
    />
  </CDropdown>
</template>

<script setup lang="ts">
import { h, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import useThemeVars from '@lib/composables/useThemeVars'
import tooltipDirective from '@lib/directives/tooltip'
import CDropdown from '@lib/components/CDropdown/CDropdown.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import CCatalogIqSwitcherContent from '@lib/components/CCatalogIqSwitcher/CCatalogIqSwitcherContent.vue'
import type { Props } from './CCatalogIqSwitcher.types'

const props = withDefaults(defineProps<Props>(), {
  app: 'impact',
})
const show = ref(false)
const { t } = useI18n()
const themeVars = useThemeVars()
const vTooltip = tooltipDirective
const close = () => {
  show.value = false
}

function renderSwitcherContent() {
  return h(CCatalogIqSwitcherContent, {
    ...props,
    onClick: () => close(),
  })
}

function onClickOutside() {
  setTimeout(() => close())
}
</script>
